import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Modulos } from 'src/app/core/modulos';
import { AcessoModuloResolver } from 'src/app/guards/acesso-modulo.resolve';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { FrequenciaAlunoUnidadeComponent } from './frequencia-aluno-unidade.component';


const routes: Routes = [
  { path: 'frequenciaalunounidade', component: FrequenciaAlunoUnidadeComponent,canActivate: [AuthGuard],resolve: {perfilAcesso:AcessoModuloResolver}, data:{modulo:Modulos.FREQUENCIA_ALUNO}},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FrequenciaAlunoUnidadeRoutingModule { }
